<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    children?: Snippet;
  }

  const { children }: Props = $props();
</script>

<div class="segmented-control" role="radiogroup">
  {@render children?.()}
</div>

<style>
  @reference "#tailwind.css";
  .segmented-control {
    @apply relative flex h-7 items-center rounded-full bg-mono-000 p-0.5 text-sm text-foreground-tertiary shadow-border-inset has-[:focus-visible]:outline has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-focus;
  }
</style>
